import MuhammadMuzammal from '../assets/pdf/mmuzammal.pdf'
import ProfileImg from '../assets/png/IMG_4534.JPG'
// import ProfileImg2 from '../assets/png/f3bfe2cc-7da3-452f-89c7-9aaf1a4282b8.jpg'



export const headerData = {
    name: 'Muhammad Muzammal',
    title: "Front End Developer",
    desciption:"Dedicated React.js Web Developer with 2 years of experience in front-end development. Proficient in React.js, Bootstrap, Material UI, Vanilla JS, ES6,  HTML, CSS, Postman, API integration and MySql. A quick learner who thrives on challenges, I am eager to grow my full-stack skills and contribute to impactful projects.",
    image: ProfileImg,
    resumePdf: MuhammadMuzammal
}
  